import { createAPI } from '../../composable/useAPI';


export const useContractAPI = () =>{
  const api = createAPI();

  const request = {
    contract : {
      get: async (params) => {
        try {
          const response = await api.get('/api/v2/contract', { params });
          return response.data.data;
        } catch (error) {
          console.error('GET request failed:', error);
          throw error;
        }
      },
      post: async (data) => {
        try {
          const response = await api.post('/api/v2/contract', data);
          return response.status === 200;
        } catch (error) {
          console.error('POST request failed:', error);
          return false;
        }
      },
      put: async (data) => {
        try {
          const response = await api.put('/api/v2/contract', data);
          return response.status === 200;
        } catch (error) {
          console.error('PUT request failed:', error);
          return false;
        }
      },
      complete: async (data) => {
        try {
          const response = await api.put('/api/v2/contract/complete', data);
          return response.status === 200;
        } catch (error) {
          console.error('PUT request failed:', error);
          return false;
        }
      },
      delete: async(params) => {
        try{
          const queryString = params.map((seq) => `contractSeq=${seq}`).join('&');
          const response = api.delete(`/api/v2/contract?${queryString}`);
          return response;
        } catch(error) {
          console.error('PUT request failed:', error);
          return false;
        }
      },
      import: async (formData) => {
        try {
          const response = await api.post('/api/v2/contract/import', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials: true,
          });
          return response.data;
        } catch (error) {
          console.error('엑셀 업로드 실패:', error);
          return false;
        }
      },
      download: async (params) => {
        try {
          const res = await api.get('/api/v2/contract/download', {
            params,
            responseType: 'blob',
          });
          const contentType =
            res.headers['content-type'] ||
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          let filename = '수주_목록.xlsx';
          const dispo = res.headers['content-disposition'];
          if (dispo) {
            const m = /filename\*=UTF-8''([^;]+)|filename="([^"]+)"/i.exec(dispo);
            const raw = m?.[1] || m?.[2];
            if (raw) {
              try { filename = decodeURIComponent(raw); } catch { filename = raw; }
            }
          }
          const blob = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        } catch (err) {
          console.error('다운로드 실패:', err);
          throw err;
        }
      }
    }
  };

  return {
    ...request
  }
}
